/* eslint-disable */
import * as React from "react";

import { ReportRenderer } from "../../../shared";
import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { ReportGrid } from "../../../components/ReportGrid";

import { CommoditiesControl } from "../controls/CommoditiesControl";
import { CalendarControl } from "../controls/CalendarControl";

import { useSubscription } from "./useSubscription";

export default function () {
  useSubscription();
  return (
    <>
      <ReportToolbarGroup>
        <CommoditiesControl />
        <div style={{ display: "none" }}>
          <CalendarControl />
        </div>
      </ReportToolbarGroup>
      <div style={{ display: "none" }}>
        <ReportGrid>
          <ReportRenderer componentId="chart-area-production-yield" />
          <ReportRenderer componentId="chart-net-trade" />
        </ReportGrid>
      </div>
    </>
  );
}
